// extracted by mini-css-extract-plugin
export default {"container":"MyInput_container__VAQMe","input":"MyInput_input__rQpOW","error":"MyInput_error__CO38i"};